import { VIDEO_SERVER_BASE_URL } from "../config/videoServer";
import type { AccessIdentity } from "./accessTracking";

export type ChannelSubscription = {
  channelId: string;
  channel: string;
  subscribedAt: string;
};

export type ViewerWatchHistoryItem = {
  videoId: string;
  videoTitle: string;
  lastWatchedAt: string;
  lastPositionSeconds: number;
  resumePositionSeconds: number;
  totalWatchSeconds: number;
  openCount: number;
  completed: boolean;
};

async function responseJson<T>(response: Response): Promise<T> {
  const body = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(body.error || `请求失败 (${response.status})`);
  }
  return body as T;
}

export async function fetchViewerWatchHistory(
  _identity: AccessIdentity,
  limit = 100,
) {
  const params = new URLSearchParams({ limit: String(limit) });
  const body = await responseJson<{
    items?: ViewerWatchHistoryItem[];
    retentionDays?: number;
  }>(await fetch(`${VIDEO_SERVER_BASE_URL}/api/me/watch-history?${params}`, {
    cache: "no-store",
    credentials: "include",
  }));
  return {
    items: Array.isArray(body.items) ? body.items : [],
    retentionDays: typeof body.retentionDays === "number" ? body.retentionDays : 90,
  };
}

export async function fetchChannelSubscriptions(_identity: AccessIdentity) {
  const body = await responseJson<{ channels?: ChannelSubscription[] }>(
    await fetch(`${VIDEO_SERVER_BASE_URL}/api/me/subscriptions`, {
      cache: "no-store",
      credentials: "include",
    }),
  );
  return Array.isArray(body.channels) ? body.channels : [];
}

export async function setChannelSubscription(
  _identity: AccessIdentity,
  channelId: string,
  subscribed: boolean,
) {
  return responseJson<{
    accepted: boolean;
    subscribed: boolean;
    channelId: string;
    channel?: string;
    timestamp?: string;
  }>(await fetch(
    `${VIDEO_SERVER_BASE_URL}/api/me/subscriptions/${encodeURIComponent(channelId)}`,
    {
      method: subscribed ? "PUT" : "DELETE",
      credentials: "include",
    },
  ));
}
